import * as React from 'react';
import * as S from '../';

type Value = Record<string, any>;

export type TBatcherSelect = {
    type: 'batcher',
    name: string,
    onSelect: (x: unknown, name: string) => void,
    onAction: (x: Record<string, any> | null, name: string) => void,
    value?: Value | null,
    data: Value[],
    onClear?: (name: string) => void,
    placeholder?: string,
    disabled?: boolean,
}

const Component  = React.forwardRef<HTMLInputElement, TBatcherSelect>(({
    name,
    onSelect,
    onAction,
    value = null,
    data,
    onClear,
    placeholder,
    disabled,
}, ref) => {
    return (
        <S.Select 
            name={name}
            onSelect={onSelect}
            onClear={onClear}>
            <S.Control disabled={disabled}>
                <S.ControlInput
                    ref={ref}
                    value={value}
                    placeholder={placeholder}
                />
                <S.Action onAction={onAction} />
            </S.Control>
            <S.Indicator />
            <S.List data={data}>
                <S.Item>{(x) => <span>{x.text as any}</span>}</S.Item>
                <S.Error>Данных нет.</S.Error>
            </S.List>
            <S.Dropdown maxHeight={250} />
            <S.Cursor />
            <S.Setter />
            <S.Keyboard />
        </S.Select>
    );
});

export default Component;
